import { LanguageIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/solid';
import { postDataAPI } from '../../Helpers/FetchAPI';

export const TranslateLessonButton = ({ lessonId, language, setLesson }) => {
  const [loading, setLoading] = useState(false);
  return (
    <div
      className="__translate-button relative size-12 cursor-pointer rounded-full p-2 hover:bg-gray-200"
      onClick={(e) => {
        e.stopPropagation();
        setLoading(true);
        postDataAPI(`/api/translate/lesson`, { lessonId, language })
          .then((res) => res.data)
          .then((data) => {
            const workbook = data.workbook;
            const chapter = workbook.chapters.find((c) => c.lessons.find((l) => l._id === lessonId));
            const lesson = chapter.lessons.find((l) => l._id === lessonId);
            setLesson(lesson);
            setLoading(false);
          });
      }}
    >
      <ArrowPathIcon
        className={`absolute top-1/2 left-1/2 size-8 -translate-1/2 transition-all duration-300 ease-out ${loading ? 'animate-spin opacity-100' : 'opacity-0'}`}
      />
      <LanguageIcon
        className={`absolute top-1/2 left-1/2 size-8 -translate-1/2 transition-all duration-300 ease-out ${loading ? 'opacity-0' : 'opacity-100'}`}
      />
    </div>
  );
};
